<template>
  <div class="container">
    <div class="row">

      <div class="col">


        <div class="card">
          <h2 class="blanco">Login</h2>
          <div class="form">

            <form id="loginForm" >
              <div class="blanco">

              </div>
              <div class="mb-3">
                <label for="exampleInputEmail1" class="blanco form-label">Correo o Usuario</label>
                <input v-model="usuarioLogin.nombreUsuarioOrEmail" type="email" class="form-control" id="emailLogin" aria-describedby="emailHelp" required>

              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="blanco form-label">Contraseña</label>
                <input v-model="usuarioLogin.password" type="password" class="form-control" id="passwordLogin" required>
              </div>


              <button @click="obtenerDatos" class="btn btn-primary form-control">
                Ingresar
              </button>



            </form>

          </div>


        </div>
      </div>

    </div>
  </div>
</template>

<script>

import {computed} from "vue";
import {useStore} from "vuex";
import {ref} from "vue";


export default {
  name: "Login",
  setup(){

    let usuarioLogin = ref({});

    const store = useStore();
    const usuario = computed(() => store.state.userStore.usuario);
    // console.log(usuario.value)
    // console.log(usuario.value)

    const obtenerDatos = async () => {
      store.dispatch("userStore/login",usuarioLogin.value)
      //console.log(usuarioLogin.value.password)
      usuarioLogin.value.nombreUsuarioOrEmail = "";
      usuarioLogin.value.password = "";
    }

    return {
      usuario,usuarioLogin, obtenerDatos
    }

  }
}
</script>














<style scoped>

.col {
  display: flex;
  justify-content: center;
}


.card {
  display: flex;
  justify-content: center;
  width: 18rem;
  margin-top: 5vh;
  margin-left: 15vh;
  margin-bottom: 30vh;
  background-color: rgb(59, 61, 68);
}

body {
  background-image: linear-gradient(to bottom right, rgba(45, 117, 165, 0.972), rgb(101, 42, 156));
  background-size: 100%;
  height: 100%;
}

.form {
  padding: 20px;
}
.container {
  height: 100%;
}

.blanco {
  color: whitesmoke;
}


.link-registro a {
  color: rgb(138, 180, 167);

}

.link-registro a:hover {
  color: rgb(93, 111, 133);

}

span{
  color: whitesmoke;
}


h2 {
  text-align:center;
}



</style>